export default __webpack_public_path__ + "static/media/add-step1.3f671b62.svg";